var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClosePopupIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6036_23299",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6036_23299",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACiklEQVR4nO2czU4UQRRGL6NPogF1pVGGr5iNT8EDqLeax5gnMiESozt8IZWE6PizwFQPY0RBukfw3rr1naR3LKrO6aoeujstQgghhBBCCCGEEEIIIYRUx4bEZkNcMtNHgvxWkBeS8ldBPpTd7r5EAS8eSMoHkvS4n2OZ687+Q/EjX08k5dNzB/JHQQepHXTo5/LH/PTER4RyNvw+uJ9HOWMqjoAO/Rwumx/0jfEI55Ozbec0XARcIX+5yhf21wXo578HqDACBshfzuuT9VBleXG6aqAVRcBQ+f3x0nq4IrPu7oUXqRojYIT8MuftZ3fEBal7LMjvB0fY0STegD4R6Id6T6SaI6B2+TVHQBT5NUZANPk1RUBU+TVEQHT5niOgFfkeI6A1+Z4ioFX5HiKgdfmWEUD5dhFA+XYRQPl2EUD5dhFA+XYRQPl2EUD5dhFA+XYRQPmGD8X1eNTfhv0P13QlZMr3HUF55ttFUMq3WwlK+XYRlPKvFYz5qTnitgW5CfmM4EB+5kqwl58ZwV5+ZoTx8jveijADa9xY8/DKSwjwD3c1GcFQ/gpGWBNc4/18RjCUv4IRBnKTT7ISL8x28lcwwiX8z2e4iSvBTv4KRjjD8u2F1PpK8PDqSGo1ggf5zUbwJL+5CB7lNxPBs/zwEWqQHzZCTfLDRahRfpgINcuvPsLs+b1mP1k21S0PH+17HUL+ehEOxZS9vVv9p4qjyB+7HUG/9A7MeDq/LdDvoeSPiqDfbAMUoO/CyR++HR2JObt5euHni8N/vDsvZNptiwtKhHI2lO2o7IvQV4L9TYnCVLf6C+5ybmXLPfIj/1f6/XA+kbDMJ/Z7PiGEEEIIIYQQQgghhBAiY/kBQiyobPurN0YAAAAASUVORK5CYII="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClosePopupIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-popup-icon.22436b96c5d082d1f7892300408f87e7.svg";